import { Injectable } from '@angular/core';
import { DataService } from './../../../../Autofacets-Core/src/app/services/data.service';
import { GenericResponse } from '../../../../Autofacets-Core/src/app/business-entities/generic-response.class';
import { Urls } from './../../../../Autofacets-Core/src/app/utils/urls';
import { AgentDetailsRequestModel, DealerWiseAgentListRequestModel } from '../business-entities/agent-efficiency-model';
@Injectable({
    providedIn: 'root'
  })
export class AgentEfficiencyDataService{
    constructor(private dataService: DataService) { }
    async getDealerWiseAgentList(requestModel: DealerWiseAgentListRequestModel): Promise<GenericResponse<any>> {
        return this.dataService.Post<GenericResponse<any>>(Urls.GetDealerWiseAgentList, requestModel).toPromise();
    }
    async getAgentDetailsList(requestModel: AgentDetailsRequestModel): Promise<GenericResponse<any>> {
        return this.dataService.Post<GenericResponse<any>>(Urls.GetAgentDetailsList, requestModel).toPromise();
    }
}